import React, { memo, useEffect, useState, useRef, useCallback, forwardRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import screenfull from 'screenfull'
import { Timestamp } from 'firebase/firestore'
import { intersection, isEmpty } from 'lodash'
import axios from 'axios'

import {
  GET_MEDIA,
  GET_MDSTRM_ACCESS_TOKEN,
  SET_CONTINUE_WATCHING,
  GET_MEDIA_SUCCESS,
  GET_MDSTRM_ACCESS_TOKEN_SEARCH_AGAIN,
  GET_MDSTRM_ACCESS_TOKEN_SUCCESS,
  GET_MDSTRM_ACCESS_TOKEN_SEARCH_AGAIN_SUCCESS
} from '../../redux/actions'

import PlayerVerticalContainer from '../../containers/player/PlayerVerticalContainer'
import PlayerVerticalControls from './PlayerVerticalControls'
import Loading from '../Loading'
import { timerFormat } from '../../utils/timerFormat'
import { shouldShowAds } from '../../utils/adsUtils'
import { withError } from '../error/ErrorComponent'
import PlayerAccessAlertContainer from '../../containers/player/PlayerAccessAlertContainer'

const baseUrlThumbsImage = `${process.env.REACT_APP_API_MDSTRM_THUMBNAIL_URL}/${process.env.REACT_APP_API_MDSTRM_ACOUNT_ID_MEGA}`

const PlayerVerticalComponent = forwardRef(({ mediaId, onPlayStateChange, onMuteStateChange }, ref) => {
  const { isAuthenticated, keycloak, isLoading, idUser } = useSelector(state => state.auth)
  const { data: media, accessToken, isLoading: isLoadingMedia, isLoadingToken, error: mediaError, accessTokenSearchAgain } = useSelector(state => state.media)
  const { serie } = useSelector(state => state.series)
  const { currentProfile, error: profileError, isLoading: isLoadingProfiles } = useSelector(state => state.profiles)
  const { isLoading: isLoadingSuscription, subscriptionsPlanIds, subscriber, error: subscriptionError, planIdToHasAds } = useSelector(state => state.subscription)
  const { error: notificationsError } = useSelector(state => state.notifications)

  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isLoadingErrorSlowNet, setIsLoadingErrorSlowNet] = useState(false)
  const [hasAccess, setHasAccess] = useState(true)
  const [player, setPlayer] = useState(null)
  const [count, setCount] = useState(0)
  const [duration, setDuration] = useState(0)
  const [position, setPosition] = useState(0)
  const [elapsedTime, setElapsedTime] = useState('00:00')
  const [totalDuration, setTotalDuration] = useState('00:00')
  const [controlsVisibility, setControlsVisibility] = useState(false)
  const [nextEpisodeVisibility, setNextEpisodeVisibility] = useState(false)
  const [isBuffering, setIsBuffering] = useState(true)
  const [timerToSave, setTimerToSave] = useState(0)
  const [nextVod, setNextVod] = useState({})
  const [allVods, setAllVods] = useState([])
  const [isLoadingNextVod, setIsLoadingNextVod] = useState(true)
  const [isShowingAds, setIsShowingAds] = useState(false)
  const savedVolume = sessionStorage.getItem("megaGoCurrentVolume");
  const initialVolume = savedVolume !== null ? JSON.parse(savedVolume) : 50;
  const [playerState, setPlayerState] = useState({
    playing: true,
    muted: initialVolume === 0,
    volume: initialVolume,
    lastVolume: initialVolume === 0 ? 50 : initialVolume,
    playbackRate: 1.0,
    played: 0,
    seeking: false,
    position: position,
  })
  const [vttContent, setVttContent] = useState(null)
  const [isOffline, setIsOffline] = useState(!window.navigator.onLine)
  const [showRetry, setShowRetry] = useState(false)
  const [retryCountdown, setRetryCountdown] = useState(10)
  const [isRecovering, setIsRecovering] = useState(false)
  const playerError = 15000
  const retryToken = 5000

  const countAccessToken = useRef(0);
  const timeoutSearchAccesToken = useRef(null);

  const lastMsgAtRef = useRef(Date.now())
  const lastRecoverAtRef = useRef(0)
  const recoveringRef = useRef(false)
  const wantsPlayRef = useRef(true)
  const saveContinuePosition = useRef(0);

  const loadingTimeoutRef = useRef(null)
  const countdownIntervalRef = useRef(null)
  const [isSeeking, setIsSeeking] = useState(false)

  const playerContainerRef = useRef(null)
  // const { type, _id } = useParams()
  const type = 'vod'
  const _id = mediaId
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    !isAuthenticated && !isEmpty(keycloak) && keycloak.login()
  }, [isAuthenticated, keycloak])

  useEffect(() => {
    (isAuthenticated && !isEmpty(currentProfile))
      && dispatch(GET_MEDIA({
        keycloak,
        idCurrentProfile: currentProfile.id,
        type,
        id: _id
      }))

    return () => {
      dispatch(GET_MEDIA_SUCCESS({}))
      dispatch(GET_MDSTRM_ACCESS_TOKEN_SUCCESS({ access_token: '' }));
      dispatch(GET_MDSTRM_ACCESS_TOKEN_SEARCH_AGAIN_SUCCESS({ access_token: '' }));
      setIsLoadingError(false)
      setCount(0)
      setDuration(0)
      setPosition(0)
      setElapsedTime('00:00')
      setTotalDuration('00:00')
      setControlsVisibility(false)
      setIsBuffering(true)
      setTimerToSave(0)
      setNextVod({})
      setAllVods([])
      setIsLoadingNextVod(true)
      const currentSavedVol = sessionStorage.getItem("megaGoCurrentVolume");
      const volToSet = currentSavedVol !== null ? JSON.parse(currentSavedVol) : 50;
      setPlayerState({
        playing: true,
        muted: volToSet === 0,
        volume: volToSet,
        lastVolume: volToSet === 0 ? 50 : volToSet,
        played: 0,
        seeking: false
      })
      setPlayer(null)
      saveContinuePosition.current = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, currentProfile.id])

  const hasAccessToCallback = useCallback(async (customerId) => {
    try {
      const headers = { timeout: 10000 }

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_TLBX_URL}hasAccessTo?customerId=${customerId}`,
        headers
      )

      return data
    } catch {
      return []
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(media)) {
      const contentPlanIds = type === 'live' ? (media.planIds || []) : (media.serie.planIds || [])

      if (isEmpty(intersection(subscriptionsPlanIds, contentPlanIds)) && media.pay === true) {
        navigate({
          pathname: '/planes',
          search: serie.preferredPlan ? `?preferredPlan=${serie.preferredPlan}` : ''
        })
      } else if (!isEmpty(subscriber.idp) && media.pay === true) {
        setIsLoadingError(true)
        hasAccessToCallback(subscriber.external_customer_id)
          .then(urns => {
            const urnsFiltered = urns.filter(urn => urn === 'urn:tve:mgofullfijo')
            if (!isEmpty(urnsFiltered)) {
              media.position !== undefined
                && media.position !== null
                && !media.isViewed
                && setPosition(media.position)
              setHasAccess(true)
            } else {
              setHasAccess(false)
            }
          })
      } else {
        media.position !== undefined
          && media.position !== null
          && !media.isViewed
          && setPosition(media.position)

        setHasAccess(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media])

  useEffect(() => {
    !isEmpty(media) && media._id === _id
      && dispatch(GET_MDSTRM_ACCESS_TOKEN({
        keycloak,
        id: media.idMedia,
        type: type === 'vod' ? 'media' : type,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media])

  useEffect(() => {
    if (type !== 'live' && hasAccess) {
      if (!isEmpty(media)) {
        const allVodsAux = allVods
        if (isEmpty(allVodsAux) && media.serie !== null) {
          const serie = media.serie
          serie.seasons.forEach(season => season.vods?.forEach(vod => allVodsAux.push(vod)))
          setAllVods(allVodsAux)
        } else if (isEmpty(allVodsAux) && media.event !== null) {
          const event = media.event
          event.sections.forEach(section => section.content?.forEach(contents => allVodsAux.push(contents)))
          setAllVods(allVodsAux)
        }
        if (!isEmpty(allVodsAux)) {
          const mediaIndex = allVodsAux.findIndex(vod => vod._id === media._id)
          setNextVod(allVodsAux[mediaIndex]._id === allVodsAux[allVodsAux.length - 1]._id
            ? {}
            : allVodsAux[mediaIndex + 1]
          )
        }
        setIsLoadingNextVod(false)
      }
    } else {
      setIsLoadingNextVod(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media])

  useEffect(() => {
    if (type !== 'live' && hasAccess) {
      if (!isEmpty(player) && player.isReady()) {
        setPlayerState({ ...playerState, played: (position / duration) })
        setElapsedTime(timerFormat(position))
        setTotalDuration(timerFormat(duration))
        player.seekTo(position)
        player.videoPlay()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player, duration])

  useEffect(() => {
    const onMsg = (ev) => {
      if (ev.origin !== 'https://mdstrm.com') return;
      const name = ev?.data?.eventName;
      if (!name) return;
      if (name === 'onTimeUpdate' || name === 'onBuffering' || name === 'onPlay') {
        lastMsgAtRef.current = Date.now();
      }
      if (name === 'onPlay') {
        wantsPlayRef.current = true;
        setPlayerState(prev => ({ ...prev, playing: true }));
        if (onPlayStateChange) onPlayStateChange(true);
        if (recoveringRef.current) {
          recoveringRef.current = false;
          setIsRecovering(false);
          setIsLoadingError(false);
        }
      }
      if (name === 'onPause' || name === 'onVideoEnd') {
        wantsPlayRef.current = false;
        setPlayerState(prev => ({ ...prev, playing: false }));
        if (onPlayStateChange) onPlayStateChange(false);
        lastMsgAtRef.current = Date.now();
      }
    };
    window.addEventListener('message', onMsg);
    return () => {
      window.removeEventListener('message', onMsg)
      dispatch(GET_MDSTRM_ACCESS_TOKEN_SUCCESS({ access_token: '' }));
      dispatch(GET_MDSTRM_ACCESS_TOKEN_SEARCH_AGAIN_SUCCESS({ access_token: '' }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onPlayStateChange]);


  const recover = useCallback(() => {
    if (timeoutSearchAccesToken.current) clearTimeout(timeoutSearchAccesToken.current)
    const now = Date.now();
    if (now - lastRecoverAtRef.current < retryToken) return;
    if (!isEmpty(media)) {
      recoveringRef.current = true;
      lastRecoverAtRef.current = now;
      setIsRecovering(true);
      const savePosition = position;
      saveContinuePosition.current = savePosition;
      countAccessToken.current = countAccessToken.current + 1;
      dispatch(GET_MDSTRM_ACCESS_TOKEN_SEARCH_AGAIN({
        keycloak,
        id: media.idMedia,
        type: type === 'vod' ? 'media' : type,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, keycloak, media?.idMedia, type, player, position]);

  useEffect(() => {
    if (accessToken !== accessTokenSearchAgain) {
      if (!player?.isReady() && !isEmpty(accessTokenSearchAgain)) {
        if (player !== 'undefined') {
          try { player?.destroy?.(); } catch { }
          try { player?.videoStop?.(); } catch { }
          setPlayer(null);
        }
        dispatch(GET_MDSTRM_ACCESS_TOKEN_SUCCESS({ access_token: accessTokenSearchAgain }));
      }
      if (countAccessToken.current > 5) {
        setIsLoadingErrorSlowNet(true);
        countAccessToken.current = 0;
        wantsPlayRef.current = false;
        timeoutSearchAccesToken.current = setTimeout(() => {
          setIsLoadingErrorSlowNet(false);
          wantsPlayRef.current = true; //para volver a buscar token
        }, 15000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessTokenSearchAgain, countAccessToken?.current])

  useEffect(() => {
    const id = setInterval(() => {
      const silentFor = Date.now() - lastMsgAtRef.current;
      if (!window.navigator.onLine) return;// Si no hay conexion, no intentar recover
      if (isSeeking && !(silentFor > playerError)) return;
      if (wantsPlayRef.current && silentFor > playerError) {
        setIsRecovering(true);
        recover();
      }
    }, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recover]);

  useEffect(() => {
    if (
      isEmpty(player)
      && !isEmpty(accessToken)
      && !isEmpty(media)
      && !isLoading
      && !isLoadingMedia
      && !isLoadingSuscription
      && !isLoadingToken
      && !isLoadingNextVod
      && !isLoadingProfiles
      && hasAccess
    ) {
      const playerOptions = {
        width: 1080,
        height: 720,
        type: type === 'live' ? 'live' : "media",
        id: media.idMedia,
        access_token: accessToken,
        autoplay: true,
        player: process.env.REACT_APP_MDSTRM_ID_PLAYER,
        controls: false,
        show_controls_on_ad: true,
        pause_on_screen_click: false,
        pause_ad_on_click: false,
        customer: idUser,
        starttime: position,
        volume: sessionStorage.getItem("megaGoCurrentVolume") !== null ? JSON.parse(sessionStorage.getItem("megaGoCurrentVolume")) : 50,
        events: {
          onPlayerMounted: function (data) {
            if (type !== 'live') {
              axios.get(
                `${baseUrlThumbsImage}/${media.idMedia}/preview_${media.idMedia}.vtt`,
              ).then(({ data }) => {
                setVttContent(data)
              })
            }
          },
          onPlayerReady: function () {
            this.getDuration(playerDuration => {
              setDuration(playerDuration)
            })
          },
          onPlay: function () {
            setIsBuffering(false)
            setIsLoadingError(false)
            setIsShowingAds(false)
          },
          onVideoEnd: function () {
            if (!isEmpty(nextVod)) {
              setNextEpisodeVisibility(true)
              setControlsVisibility(false)
            } else {
              setControlsVisibility(true)
            }
          },
          onVideoError: function (e, data) {
            handleError(e, data)
          },
          onTimeUpdate: function (time) {
            setPosition(time)
          },
          onFullscreenChange: function (fullscreen) {
            console.log("Is fullscreen " + fullscreen)
          },
          onBuffering: function () {
            setIsBuffering(true)
            if (window.navigator.onLine === false) {
              setIsOffline(true);
              setIsLoadingError(true);
            }
          },
          onAdsStarted: function () {
            handleStartAds()
            setIsShowingAds(true)
            setIsBuffering(false)
          },
          onAdsAllAdsCompleted: function () {
            handleFinishAds()
            setIsShowingAds(false)
          }
        }
      }

      let env = process.env.REACT_APP_ADS_ENV;
      const kvSeccion = type === "live" ? 'senal-en-vivo' : (media.serie?.populatedCategories ? media.serie?.populatedCategories[0]?.slug : "-");
      const subSeccion = type === "live" ? media?.slug : media?.serie?.slug
      const mdsUrlId = type === "live" ? "5e289d07ce24c806d008018e" : "6aa95f7b0ce21d4c7ce14a04"; // MGO-E47-H5: ad-config propio de Shorts, separado del VOD para diferenciar en MediaStream/GAM

      const keyValue = {
        seccion: kvSeccion,
        sub_seccion: subSeccion,
        seccion_path: `${kvSeccion}/${subSeccion}`,
        app_device: "web", // MGO-E47-H5: árbol publicitario 2026, paridad con iOS
        env: env,
      };
      const queryString = new URLSearchParams(keyValue).toString();
      const encodedKV = encodeURIComponent(queryString);
      const reEncodedKV = encodeURIComponent(encodedKV);

      const mediaId = media._id
      let newKvsShows;
      const mediaIdCorrelator = media._id.replace(/[^0-9]/g, "")
      newKvsShows = `&custom.url=${process.env.REACT_APP_OTT_URL}player/${type}/${mediaId}` +
        `&custom.correlator=${mediaIdCorrelator}` +
        `&custom.desc_url=${process.env.REACT_APP_OTT_URL}player/${type}/${mediaId}` +
        // '&Vad_type=nonlinear' +
        `&custom.vid_d=${parseInt(media.duration) || 1200}`;

      // MGO-E84-H2: decidir preroll por-contenido. type es const 'vod' → siempre media.serie?.planIds.
      const contentPlanIds = type === 'live' ? (media.planIds || []) : (media.serie?.planIds || [])
      const showAds = shouldShowAds(contentPlanIds, subscriptionsPlanIds, planIdToHasAds)
      const newPlayerOptions = showAds
        ? { ...playerOptions, ads: { map: `https://mdstrm.com/ads/${mdsUrlId}/map.xml?duration=${parseInt(media.duration) || 1200}&custom.kv=${reEncodedKV}${newKvsShows}` } }
        : playerOptions

      var mdstrmPlayer = new window.MediastreamPlayer("mdstrm", newPlayerOptions)
      setPlayer(mdstrmPlayer)
      return () => {
        setPlayer(null)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accessToken,
    media,
    isLoading,
    isLoadingMedia,
    isLoadingSuscription,
    isLoadingToken,
    isLoadingNextVod,
    isLoadingProfiles
  ])

  const {
    playing,
    muted,
    volume,
    played,
    seeking
  } = playerState

  // Handle function to play or pause video
  const handlePlayPause = useCallback(() => {
    setPlayerState(prevPlayerState => {
      try {
        if (player && player.isPlaying()) {
          wantsPlayRef.current = false
          player.videoStop()
          type !== 'live' && prevPlayerState.playing && position >= 10 && (media.serie?.seasons[0]?.vods?.length ?? 0) > 0
            && dispatch(SET_CONTINUE_WATCHING({
              keycloak,
              idCurrentProfile: currentProfile.id,
              continueWatching: {
                id: _id,
                duration,
                position,
                serieId: media.serie._id,
                viewedLastAt: Timestamp.fromDate(new Date()),
                isViewed: duration - position <= 10
              }
            }))
          if (onPlayStateChange) onPlayStateChange(false);
          return { ...prevPlayerState, playing: false };
        } else if (player) {
          wantsPlayRef.current = true
          player.videoPlay()
          if (onPlayStateChange) onPlayStateChange(true);
          return { ...prevPlayerState, playing: true };
        }
      }
      catch (err) {
        console.error(err)
      }
      return prevPlayerState; // Return current state if no change or error
    });
  }, [player, onPlayStateChange, dispatch, keycloak, currentProfile.id, _id, duration, position, media.serie, type]);


  const handleStartAds = () => {
    try {
      wantsPlayRef.current = false
      setPlayerState({ ...playerState, playing: false })
      player.videoStop()
    }
    catch (err) {
      console.error(err)
    }
  }

  const handleFinishAds = () => {
    try {
      // wantsPlayRef.current = true
      setPlayerState({ ...playerState, playing: true })
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle continue watching
  const handleContinueWatching = () => {
    try {
      type !== 'live' && position >= 10
        && dispatch(SET_CONTINUE_WATCHING({
          keycloak,
          idCurrentProfile: currentProfile.id,
          continueWatching: {
            id: _id,
            duration,
            position,
            serieId: media.serie !== null ? media.serie._id : media.event._id,
            viewedLastAt: Timestamp.fromDate(new Date()),
            isViewed: duration - position <= 10
          }
        }))
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle rewind <<< player
  const handleRewind = () => {
    try {
      player.getCurrentTime(currentTime => player.seekTo(currentTime - 10))
      setCount(0)
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle forward >>> player
  const handleForward = () => {
    try {
      player.getCurrentTime(currentTime => player.seekTo(currentTime + 10))
      setCount(0);
    }
    catch (err) {
      console.error(err)
    }
  }

  // Save current volume on sesion storage
  const saveVolume = (setedVolume) => {
    sessionStorage.setItem("megaGoCurrentVolume", setedVolume)
  }

  // Handle when volume change
  const handleVolumeChange = (e, newValue) => {
    try {
      setPlayerState({ ...playerState, volume: newValue, lastVolume: newValue, muted: newValue === 0 ? true : false })
      saveVolume(parseFloat(newValue))
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle volume comited change
  const handleVolumeSeekUp = (e, newValue) => {
    try {
      setPlayerState({ ...playerState, volume: newValue, lastVolume: newValue, muted: newValue === 0 ? true : false })
      saveVolume(newValue)
      if (onMuteStateChange) onMuteStateChange(newValue === 0);
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle mute function
  const handleMute = useCallback(() => {
    setPlayerState(prevPlayerState => {
      const nextMuted = !prevPlayerState.muted;
      const nextVolume = nextMuted ? 0 : prevPlayerState.lastVolume;
      saveVolume(nextVolume);
      if (onMuteStateChange) onMuteStateChange(nextMuted);
      return { ...prevPlayerState, volume: nextVolume, muted: nextMuted };
    });
  }, [onMuteStateChange]);

  // Exponer el control de play/pause al padre después de definir las funciones
  useImperativeHandle(ref, () => ({
    handlePlayPause,
    handleMute,
    isPlaying: playing
  }), [handlePlayPause, handleMute, playing]);

  // Change volume on state change
  useEffect(() => {
    try {
      if (!isEmpty(player) && player.isReady()) {
        player.setVolume(volume);
        // También aseguramos que el estado de muted se aplique correctamente
        if (player.isMuted() !== muted) {
          player.setMute(muted);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, [player, volume, muted]); // Añadir 'player' a las dependencias

  // Handle fullscreen
  const toggleFullScreen = () => {
    try {
      screenfull.toggle(playerContainerRef.current)
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle progress time of player
  const handleProgress = (time) => {
    try {
      setIsLoadingErrorSlowNet(false)
      if (timeoutSearchAccesToken.current) clearTimeout(timeoutSearchAccesToken.current)
      if (saveContinuePosition.current > 0) {
        player.seekTo(saveContinuePosition.current);
        saveContinuePosition.current = 0;
      }
      if (count > 4) {
        setControlsVisibility(false)
        // document.body.style.cursor = 'none'
      }
      if (controlsVisibility) {
        setCount(count + 1)
      }
      if (!seeking && type !== 'live') {
        setPlayerState({
          ...playerState,
          played: (time / duration) * 100,
        })
        setElapsedTime(timerFormat(time))
      }
      if (!isBuffering && playing && type !== 'live') {
        if (timerToSave >= 30) {
          dispatch(SET_CONTINUE_WATCHING({
            keycloak,
            idCurrentProfile: currentProfile.id,
            continueWatching: {
              id: _id,
              duration,
              position,
              serieId: media.serie !== null ? media.serie._id : media.event._id,
              viewedLastAt: Timestamp.fromDate(new Date()),
              isViewed: duration - position <= 10
            }
          }))
          setTimerToSave(0)
        } else {
          setTimerToSave(timerToSave + 1)
        }
      }
    }
    catch (err) {
      console.error(err)
    }
  }

  // Set position in time bar
  useEffect(() => {
    handleProgress(position)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, duration])

  // Handle when mouse moves seeking
  const handleSeekChange = (e, newValue) => {
    try {
      setPlayerState({ ...playerState, played: newValue })
      player.seekTo((newValue / 100) * duration)
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle when mouse down on seeking the player time slider
  const handleSeekMouseDown = (e) => {
    try {
      setPlayerState({ ...playerState, playing: false, seeking: true })
      player.videoStop()
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle when mouse up on seeking the player time slider
  const handleSeekMouseUp = (e, newValue) => {
    try {
      setPlayerState({ ...playerState, playing: true, seeking: false, played: newValue })
      player.seekTo((newValue / 100) * duration)
      player.videoPlay()
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle when mouse move on player
  const handleMouseMove = () => {
    try {
      setControlsVisibility(true)
      document.body.style.cursor = 'auto'
      setCount(0)
    }
    catch (err) {
      console.error(err)
    }
  }

  // Handle when mouse leave screen or player area
  const handleMouseLeave = () => {
    try {
      setControlsVisibility(false)
    }
    catch (err) {
      console.error(err)
    }
  }

  function retryPlayback() {
    if (!navigator.onLine) {
      setIsLoadingError(true);
      return;
    }
    setIsOffline(false);

    if (player && typeof player.videoPlay === 'function') {
      try {
        player.videoPlay();
        setIsLoadingError(false);
      } catch (err) {
        setIsLoadingError(true);
      }
    }
  }

  useEffect(() => {
    const clearTimers = () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current)
        loadingTimeoutRef.current = null
      }
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current)
        countdownIntervalRef.current = null
      }
    }

    if (!isOffline) {
      clearTimers()
      setShowRetry(false)
      setRetryCountdown(10)
      return
    }

    if (!showRetry) {
      setRetryCountdown(10)
      clearTimers()
      loadingTimeoutRef.current = setTimeout(() => {
        setShowRetry(true)
        setRetryCountdown(10)
        countdownIntervalRef.current = setInterval(() => {
          setRetryCountdown(prev => {
            if (prev <= 1) {
              clearInterval(countdownIntervalRef.current)
              countdownIntervalRef.current = null
              return 0
            }
            return prev - 1
          })
        }, 1000)
      }, 15000)
    } else {
      if (!countdownIntervalRef.current && retryCountdown > 0) {
        countdownIntervalRef.current = setInterval(() => {
          setRetryCountdown(prev => {
            if (prev <= 1) {
              clearInterval(countdownIntervalRef.current)
              countdownIntervalRef.current = null
              return 0
            }
            return prev - 1
          })
        }, 1000)
      }
    }

    return () => {
      clearTimers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOffline, showRetry])
  
  useEffect(() => {
    let offlineTimeout = null;
    let retryInterval = null;

    if (isOffline) {
      offlineTimeout = setTimeout(() => {
        setShowRetry(true);
        setRetryCountdown(10);
        retryInterval = setInterval(() => {
          setRetryCountdown(prev => {
            if (prev <= 1) {
              clearInterval(retryInterval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }, 15000);
    } else {
      setShowRetry(false);
      setRetryCountdown(15);
      if (offlineTimeout) clearTimeout(offlineTimeout);
      if (retryInterval) clearInterval(retryInterval);
    }

    return () => {
      if (offlineTimeout) clearTimeout(offlineTimeout);
      if (retryInterval) clearInterval(retryInterval);
    };
  }, [isOffline]);

  const handleRetryClick = () => {
    setShowRetry(false);
    setRetryCountdown(10);
    retryPlayback();
  };

  useEffect(() => {
    if (retryCountdown === 0 && showRetry) {
      retryPlayback();
      setShowRetry(false);
      setRetryCountdown(10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryCountdown, showRetry]);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      if (player) {
        if (type === 'live' && isBuffering) {
          player.seekTo('live');
          setIsLoadingError(false);
        } else {
          player.videoPlay();
          setIsLoadingError(false);
        }
      }
    }
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('online', handleOnline);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);


  // Handle player errors
  const handleError = (e, data) => {
    try {
      if (e.srcElement && e.srcElement.error) {
        setIsLoadingError(true)
        console.table('playerRef', player)
        console.table('event', e)

        switch (e.srcElement.error.code) {
          case 2: {
            console.log('fatal network error encountered, try to recover: ' + e.srcElement.error.message)
            let hls = player.getInternalPlayer('hls')
            hls.startLoad()
            break
          }
          case 3: {
            try {
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  console.log("wait 50ms")
                  resolve(true)
                }, 50)
              }).then((result) => {
                let hls = player.getInternalPlayer('hls')
                console.log('fatal media error encountered, try to recover: ' + e.srcElement.error.message)
                hls.swapAudioCodec()
                hls.recoverMediaError()
                console.log('fatal media error recovered: ')
              })
              break
            }
            catch (ex2) {
              console.error('fatal media error not recovered: ', ex2)
              break
            }
          }
          default: {
            break
          }
        }
      }
      else {
        if (data) {
          console.table('data', data)
        }
      }
    }
    catch (error) {
      console.log("error on recover")
      console.table(error)
    }
  }

  // Functions when go back button is pressed
  const handleOnClose = () => {
    if (location.key === 'default') {
      navigate('/', { replace: true })
    } else {
      navigate(-1)
    }
    document.body.style.cursor = 'auto'
    type !== 'live' && position >= 10 && (media.serie?.seasons[0]?.vods?.length ?? 0) > 0
      && dispatch(SET_CONTINUE_WATCHING({
        keycloak,
        idCurrentProfile: currentProfile.id,
        continueWatching: {
          id: _id,
          duration,
          position,
          serieId: media.serie !== null ? media.serie._id : media.event._id,
          viewedLastAt: Timestamp.fromDate(new Date()),
          isViewed: duration - position <= 10
        }
      }))
  }

  const handleProfileErrorOnClose = () => {
    if (type === "vod" && serie?._id) {
      const serieId = serie._id
      window.location.href = `/serie/${serieId}`
    } else {
      window.location.href = '/inicio'
    }
  }
  const isProblem = isLoadingError || isOffline || isRecovering
  const showLoader = isBuffering || isProblem;

  // TODO: Implementar al cambiar a SHAKA Player
  // const canvasRef = useRef(null);

  // useEffect(() => {
  //   // const video = videoRef.current;
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext('2d', { alpha: false }); // Optimización de rendimiento
  //   let animationId;

  //   const updateCanvas = () => {
  //     // if (video.paused || video.ended) return;

  //     // Dibujamos el frame del video en el canvas
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      
  //     // Solicitamos el siguiente frame
  //     animationId = requestAnimationFrame(updateCanvas);
  //   };

  //   // const handlePlay = () => {
  //   //   updateCanvas();
  //   // };

  //   // const handlePause = () => {
  //   //   cancelAnimationFrame(animationId);
  //   // };

  //   // video.addEventListener('play', handlePlay);
  //   // video.addEventListener('pause', handlePause);

  //   return () => {
  //     // video.removeEventListener('play', handlePlay);
  //     // video.removeEventListener('pause', handlePause);
  //     cancelAnimationFrame(animationId);
  //   };
  // }, []);

  return (
    (profileError || mediaError || subscriptionError || notificationsError)
      ? <PlayerAccessAlertContainer handleOnClose={handleProfileErrorOnClose} error={profileError || mediaError || subscriptionError || notificationsError} showRetryButton />
      :
      (
        isLoading
        || isLoadingMedia
        || isLoadingSuscription
        || (isLoadingToken && !isProblem)
        || (type !== ('live') && (media._id !== _id))
        || isLoadingNextVod
        || isLoadingProfiles
      )
        ?
        <Loading />
        : !hasAccess
          ? <div className='accessAlert'>
            <PlayerAccessAlertContainer
              handleOnClose={handleOnClose}
              error={{
                title: 'Actualmente no cuentas con acceso a este contenido',
                body: 'Contacta a tu proveedor para obtener mayor información.'
              }}
            />
          </div>
          :
          <>
            {
              (showLoader) &&
              <Loading styles={{
                alignItems: 'center',
                background: 'rgba(0,0,0,0.8)',
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                left: 0,
                marginLeft: 0,
                marginRight: 0,
                paddingBottom: 25,
                top: 0,
                width: '100%',
                zIndex: 3,
              }}
                colorLoading={isProblem ? "#F2B13E" : "#82a0fa"}
              />
            }
            {
              (isLoadingErrorSlowNet) &&
              <div style={{
                position: 'absolute',
                top: '56%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '30px 40px',
                borderRadius: '8px',
                zIndex: 10,
                textAlign: 'center',
                width: '100%'
              }}>
                <div style={{ color: '#fff', marginBottom: 10, lineHeight: 1.3 }}>
                  No pudimos cargar el contenido.<br /> Podría deberse a una conexión inestable.
                </div>
              </div>
            }
            {
              showRetry &&
              <div style={{
                position: 'absolute',
                top: '56%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '30px 40px',
                borderRadius: '8px',
                zIndex: 10,
                textAlign: 'center'
              }}>
                <div style={{ color: '#F2B13E', marginBottom: 10, lineHeight: 1.3 }}>
                  No se pudo conectar a los servicios.<br /> Por favor, inténtalo nuevamente.
                </div>
                <div>
                  <button
                    style={{
                      background: '#FFFFFF',
                      color: '#222',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '10px 20px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      fontSize: '16px',
                      height: '40px',
                      width: "18vw",
                      justifyContent: "left"
                    }}
                    onClick={handleRetryClick}
                  >
                    Reintentar en {retryCountdown}
                  </button>
                </div>
              </div>
            }
            {
              !isShowingAds
                ? (
                  <div onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} ref={playerContainerRef}>
                    {/* <canvas
                      ref={canvasRef}
                      width="64"  // Resolución menor
                      height="36" // Mantiene relación 16:9
                      style={styles.canvas}
                    /> */}
                    <PlayerVerticalContainer
                      handleContinueWatching={handleContinueWatching}
                      navigate={navigate}
                      nextEpisodeVisibility={nextEpisodeVisibility}
                      setNextEpisodeVisibility={setNextEpisodeVisibility}
                      nextVod={nextVod}
                      isVertical={true}
                      showId={serie._id}
                    />
                    <PlayerVerticalControls
                      controlsVisibility={controlsVisibility}
                      elapsedTime={elapsedTime}
                      handleOnClose={handleOnClose}
                      navigate={navigate}
                      muted={muted}
                      onForward={handleForward}
                      onMute={handleMute}
                      onPlayPause={handlePlayPause}
                      onRewind={handleRewind}
                      onSeek={handleSeekChange}
                      onSeekMouseDown={handleSeekMouseDown}
                      onSeekMouseUp={handleSeekMouseUp}
                      onToggleFullScreen={toggleFullScreen}
                      onVolumeChange={handleVolumeChange}
                      onVolumeSeekUp={handleVolumeSeekUp}
                      played={played}
                      playing={playing}
                      duration={duration}
                      media={media}
                      type={type}
                      volume={volume}
                      nextVod={nextVod}
                      vttContent={vttContent}
                      baseUrlImage={`${baseUrlThumbsImage}/${media.idMedia}`}
                      totalDuration={totalDuration}
                      setIsSeeking={setIsSeeking}
                    />
                    {/* <div onClick={handlePlayPause} className='screenPlay'></div> */}
                  </div>
                )
                : (
                  <div ref={playerContainerRef}>
                    <PlayerVerticalContainer
                      handleContinueWatching={handleContinueWatching}
                      navigate={navigate}
                      nextEpisodeVisibility={nextEpisodeVisibility}
                      setNextEpisodeVisibility={setNextEpisodeVisibility}
                      nextVod={nextVod}
                      isVertical={true}
                      showId={serie._id}
                    />
                  </div>
                )
            }
          </>
  )
});

export default withError(memo(PlayerVerticalComponent));